import React, { Component } from 'react';
import Bouncer from '@bit/bit.gui.generic-bouncer';
import { Platform } from '@bit/bit.gui.atoms.brick-3d';
import classNames from 'classnames';

import styles from './brick-loader.module.css';

export type BrickLoaderProps = {
	className?: string;
	visible?: boolean;
};

export class SmallBrickLoader extends Component<BrickLoaderProps> {
	render() {
		const { className, visible } = this.props;
		return (
			<div
				className={classNames(styles.brickLoaderContainer, className, {
					[styles.loaderVisible]: visible,
				})}
			>
				<Bouncer size={17}>
					<Platform size={17} background="#8787F2" />
					<Platform size={17} background="#8ACFFF" />
					<Platform size={17} background="#fbd280" />
				</Bouncer>
			</div>
		);
	}
}
